import aboutImg from '../Assets/aboout-2.jpg';
import acm from '../Assets/acm logo.jpg';
import AiMl from '../Assets/AIML CLUB Final.jpg';
import Arts from '../Assets/arts.jpg';
import Broadcast from '../Assets/broadcast.jpg';
import contact from '../Assets/contact us.jpg';
import devLogo from '../Assets/devsquad.png';
import Ei from '../Assets/EI Society -FINAL.jpg';
import FST from '../Assets/FST-FINAL.jpg';
import Gate from '../Assets/GATE Gurukul-FINAL.jpg';
import Homebg from '../Assets/homeBackground.jpg';
import Nyan from '../Assets/Nyan-FINALL.jpg';
import seva from '../Assets/seva.jpg';
import jntu from '../Assets/jtnugv.jpg';
import hi from '../Assets/hi.jpeg';
import AnilSir from '../Assets/AnilSir.jpg';
import RoziMam from '../Assets/Rozi Mam.jpg';
import codeQuest1 from '../Assets/codeQuest1.jpg';
import FoodDrive from '../Assets/FoodDrive.jpg';
import Poster from '../Assets/PosterPresentation.jpg';
import AiTools from '../Assets/AiTools.jpg';
import President from '../Assets/President.jpg';
import VicePresident from '../Assets/vicePresident.jpg';
import Secretary from '../Assets/Secretary.jpg';
import Treasurer from '../Assets/Treasurer.jpg';
import Officer from '../Assets/oficer.jpg';
import AiHStudent from '../Assets/AiHStudent.jpg';
import AiViceStudent from '../Assets/AiViceStudent.jpg';
import FstHStudent from '../Assets/FstHStudent.jpg';
import FstViceStudent from '../Assets/FstViceStudent.jpg';
import EiHStudent from '../Assets/EiHStudent.jpg';
import GateHStudent from '../Assets/GateHStudent.jpg';
import GateViceStudent from '../Assets/GateViceStudent.jpg';
import eventCordinator from '../Assets/eventCordinator.jpg';
import EiFaculty from '../Assets/TirumalaRaoSir.jpg';
import ArtsHStudent from '../Assets/ArtsHStudent.png';
import ArtsViceStudent from '../Assets/ArtsViceStudent.jpg';
import SevaHStudent from '../Assets/SevHStudent.jpg';
import SevaViceStudent from '../Assets/SevaViceStudent.jpg';
import SevaFaculty from '../Assets/SevaFaculty.jpg';
import EiViceStudent from '../Assets/EiViceStudent.jpg';
import NyanHStudent from '../Assets/NyanHStudent.jpg';
import NyanViceStudent from '../Assets/NyanViceStudent.jpg';
import TechnicalLead from '../Assets/technicalLead.jpg';
import BinduMam from '../Assets/BinduMam.jpg';
import Oracle from '../Assets/oracleAcademyLogo.jpg';
import Nptel from '../Assets/NptelLogo.jpg';
import Infosys from '../Assets/infosyslogo.jpg';
import Edx from '../Assets/edxLogo.png';
import Coursera from '../Assets/courseraLogo.jpg';
import Drishya from '../Assets/Drishya.jpg';
import CyberEvent from '../Assets/CyberEvent.jpg';
import EcoPulse from '../Assets/EcoPulse.jpg';
import Outer1 from '../Assets/Outer1.jpg';
import Portfolio from '../Assets/Portfolio.jpg';
import NewMember from '../Assets/NewMember.jpg';
import AnotherMember from '../Assets/AnotherMember.jpg';
import GitHubGuide from '../Assets/GitHubGuide.jpg';
import PythonBootcamp from '../Assets/PythonBootcamp.jpg';
import AiArtShowcase from '../Assets/AiArtShowcase.jpg';
import LinkedInWorkshop from '../Assets/LinkedInWorkshop.jpg';
import Pitch from '../Assets/Pitch.jpg';
import Cinequest from '../Assets/Cinequest.jpg';
import ArtsCulture from '../Assets/AiArtShowcase.jpg';
import GameDevelopment from '../Assets/GameDevelopment.jpg';
import InnovationIncubation from '../Assets/Innovation&Incubation.jpg';

const Logos = {
  ACM: acm,
  AI: AiMl,
  EI: Ei,
  FST: FST,
  Squad: devLogo,
  Gate: Gate,
  Nyan: Nyan,
  Arts: Arts,
  Seva: seva,
  college: jntu,
  Broadcast: Broadcast,
};

const OverallStudents = {
  President: President,
  VicePresident: VicePresident,
  Secretary: Secretary,
  EventCoordinator: eventCordinator,
  TechnicalLead: TechnicalLead,
  Treasurer: Treasurer,
  Officer: Officer,
  NewMember: NewMember,
  AnotherMember: AnotherMember,
  Hod: "https://jntugvcev.edu.in/uploads/departments/faculty_photos/it/dr--tirimula-rao-benala.jpg",
};

const SubClubCoordinators = {
  'AI-H': AiHStudent,
  'AI-V': AiViceStudent,
  'Fst-H': FstHStudent,
  'Fst-V': FstViceStudent,
  'Gate-H': GateHStudent,
  'Gate-V': GateViceStudent,
  'Ei-H': EiHStudent,
  'Ei-V': EiViceStudent,
  'Arts-H': ArtsHStudent,
  'Arts-V': ArtsViceStudent,
  'Seva-H': SevaHStudent,
  'Seva-V': SevaViceStudent,
  'Nyan-H': NyanHStudent,
  'Nyan-V': NyanViceStudent,
};

const Backgrounds = {
  homebg: Homebg,
  contact: contact,
  about: aboutImg,
  hi: hi,
};

const FacultyCoordinators = {
  FST: AnilSir,
  Arts: RoziMam,
  Ei: EiFaculty,
  Seva: SevaFaculty,
  AI: BinduMam,
};

const EventsCond = {
  codeQuest1: codeQuest1,
  FoodDrive: FoodDrive,
  PosterPresent: Poster,
  AiTools: AiTools,
  Cyber1: CyberEvent,
  EcoPulse: EcoPulse,
  Outer1: Outer1,
  Portfolio: Portfolio,
  GitHubGuide: GitHubGuide,
  PythonBootcamp: PythonBootcamp,
  AiArtShowcase: AiArtShowcase,
  LinkedInWorkshop: LinkedInWorkshop,
  // NEW mappings
  Pitch: Pitch,
  Cinequest: Cinequest,
  ArtsCulture: ArtsCulture,
  GameDevelopment: GameDevelopment,
  InnovationIncubation: InnovationIncubation,
};

const Collaboration = {
  oracle: Oracle,
  Nptel: Nptel,
  Coursera: Coursera,
  Edx: Edx,
  Infosys: Infosys,
  Drishya: Drishya,
};

export {
  Logos,
  Backgrounds,
  FacultyCoordinators,
  EventsCond,
  OverallStudents,
  SubClubCoordinators,
  Collaboration,
};
